import Color from "color";
import { BookingCategory } from "PFTypes";

export const getCategoryBorderColor = (category?: BookingCategory) => {
  const background = Color(category?.color || "white");

  if (background.luminosity() < 0.05) {
    return background.mix(Color("white"), 0.5).hex();
  }

  return background.darken(0.5).hex();
};

export const NO_CATEGORY_COLOR = "paletteWhite2";
